import { render } from "./CoursesDeleteModal.vue?vue&type=template&id=dff11382"
import script from "./CoursesDeleteModal.vue?vue&type=script&lang=js"
export * from "./CoursesDeleteModal.vue?vue&type=script&lang=js"
script.render = render

export default script